var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import includes from "core-js/library/fn/array/includes";

import SchemaField from "./SchemaField";

var ArrayFieldItem = function (_Component) {
    _inherits(ArrayFieldItem, _Component);

    function ArrayFieldItem() {
        var _temp, _this, _ret;

        _classCallCheck(this, ArrayFieldItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChange = function (itemData, errorSchema) {
            var _this$props = _this.props,
                itemSchema = _this$props.itemSchema,
                index = _this$props.index;

            // set _action prop

            if (itemSchema.type === "object" && itemSchema.properties.hasOwnProperty('_action')) {

                if (itemData._action !== "delete" && itemData._action !== "create") {
                    itemData._action = "update";
                }
            }

            _this.props.onChangeIndex(index, itemData, errorSchema);
        }, _this.onMoveUp = function () {
            var index = _this.props.index;

            _this.props.onReorderIndex(index, index - 1);
        }, _this.onMoveDown = function () {
            var index = _this.props.index;

            _this.props.onReorderIndex(index, index + 1);
        }, _this.onRemoveItem = function () {
            var index = _this.props.index;

            _this.props.onRemoveIndex(index);
        }, _this.onAddBefore = function (item) {
            var index = _this.props.index;

            _this.props.onInsertAtIndex(item, index);
        }, _this.onAddAfter = function (item) {
            var index = _this.props.index;

            _this.props.onInsertAtIndex(item, index + 1);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ArrayFieldItem.prototype.isItemRequired = function isItemRequired(itemSchema) {
        if (Array.isArray(itemSchema.type)) {
            // While we don't yet support composite/nullable jsonschema types, it's
            // future-proof to check for requirement against these.
            return !includes(itemSchema.type, "null");
        }
        // All non-null array item types are inherently required by design
        return itemSchema.type !== "null";
    };

    ArrayFieldItem.prototype.render = function render() {
        var _props = this.props,
            index = _props.index,
            _props$canRemove = _props.canRemove,
            canRemove = _props$canRemove === undefined ? true : _props$canRemove,
            _props$canMoveUp = _props.canMoveUp,
            canMoveUp = _props$canMoveUp === undefined ? true : _props$canMoveUp,
            _props$canMoveDown = _props.canMoveDown,
            canMoveDown = _props$canMoveDown === undefined ? true : _props$canMoveDown,
            itemSchema = _props.itemSchema,
            itemData = _props.itemData,
            itemUiSchema = _props.itemUiSchema,
            itemId = _props.itemId,
            itemIdSchema = _props.itemIdSchema,
            itemIdPrefix = _props.itemIdPrefix,
            itemErrorSchema = _props.itemErrorSchema,
            autofocus = _props.autofocus,
            disabled = _props.disabled,
            readonly = _props.readonly,
            uiSchema = _props.uiSchema,
            registry = _props.registry,
            onBlur = _props.onBlur,
            onFocus = _props.onFocus,
            rawErrors = _props.rawErrors;

        var _orderable$removable$ = _extends({
            orderable: true,
            removable: true
        }, uiSchema["ui:options"]),
            orderable = _orderable$removable$.orderable,
            removable = _orderable$removable$.removable;

        var required = this.isItemRequired(itemSchema);

        var has = {
            moveUp: orderable && canMoveUp,
            moveDown: orderable && canMoveDown,
            remove: removable && canRemove
        };

        has.toolbar = Object.keys(has).some(function (key) {
            return has[key];
        });

        return React.createElement(SchemaField, {
            formData: itemData,
            schema: itemSchema,
            uiSchema: itemUiSchema,
            idSchema: itemIdSchema,
            errorSchema: itemErrorSchema,

            required: required,
            orderable: orderable,
            removable: removable,

            onBlur: onBlur,
            onFocus: onFocus,

            registry: this.props.registry,
            disabled: this.props.disabled,
            readonly: this.props.readonly,
            autofocus: autofocus,
            rawErrors: rawErrors,

            arrayIndex: index,
            isArrayItem: true,

            idPrefix: itemId,
            id: itemId,

            index: index,

            hasToolbar: has.toolbar,
            hasMoveUp: has.moveUp,
            hasMoveDown: has.moveDown,
            hasRemove: has.remove,

            onChange: this.onChange,

            onMoveUp: this.onMoveUp,
            onMoveDown: this.onMoveDown,

            onRemoveItem: this.onRemoveItem,

            onAddBefore: this.onAddBefore,
            onAddAfter: this.onAddAfter

        });
    };

    return ArrayFieldItem;
}(Component);

export default ArrayFieldItem;